import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import enterprise_img from "../../../../assets/image/chungnamInnovationProject_img.jpg";
import SubTab from "../SubTab/SubTab";

const ChungnamInnovationProject = () => {
  const category = "chungnamInnovationProject";
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };
  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };
  const movePage = (path) => {
    navigate(path);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {"> "}사업분야{" > "}기업 지원 사업
            </div>
            <div className="banner_main_text">기업 지원 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div
              className="navi_box business_field"
              onClick={() => handleSelect(1)}
            >
              <div className="navi_main_text">기업지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() => movePage("/fusionSupportProgram")}
                >
                  산학융합지구조성사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationProject")
                  }
                >
                  기업지원사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/localIndustryTalentDevelopment")
                  }
                >
                  인재양성사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/dangjinStartupSupport")}
                >
                  창업육성사업
                </div>
              </div>
            </div>
            <div
              className="navi_box enterprise"
              onClick={() => handleSelect(2)}
            >
              <div className="navi_main_text">충남지역혁신프로젝트 사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationProject")
                  }
                >
                  충남지역혁신프로젝트 사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationCluster")
                  }
                >
                  충남지역혁신클러스터
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/carbonNeutralInfrastructure")
                  }
                >
                  탄소중립실증인프라구축사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/EnergyGrowthSupport")}
                >
                  에너지 동반성장 상생혁력지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/LocalYouthJob")}
                >
                  충남 지역주도형 청년일자리지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/YouthJobIncentive")}
                >
                  청년일자리 도약장려금지원사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/SMECenterSupport")}
                >
                  중소기업지원센터지원 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/DormLeaseSupport")}
                >
                  산업단지 기숙사 임차지원 사업
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="sub_main_area founded "> */}
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Innovation Project Program</p>
              <h2 className="business-hero-title">충남지역혁신프로젝트 사업</h2>
              <p className="business-hero-period">
                사업기간 : 2025. 1. 1. ~ 2025. 12. 31.
              </p>
            </div>
          </div>
          <div className="sub_main_back">
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div className="project_img_box">
                <div className="chungnam-innovation-project-img1"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>
              <div className="chungnam-innovation-project-img2"></div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업 목표</div>
              </div>
              <div className="objective_box_project">
                <div className="object-txt project">
                  <span className="hl">금속소재산업 시제품 제작 지원</span>과
                  저탄소 분야
                  <span className="hl">ISO 인증지원</span>및 사업장 환경 개선
                  지원을 통해 기업의 성장동력을 지원하여
                  <span className="hl">청년인력 고용창출에 기여</span>
                </div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">최종 성과</div>
              </div>
              <div className="local_final_result_box">
                <div className="project-result-box">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th>취업</th>
                        <th>기타</th>
                        <th>세부 사업 내용</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          rowSpan={3}
                          style={{ fontSize: "15px", fontWeight: "bold" }}
                          className="result-strong"
                        >
                          66명
                        </td>
                        <td>시제품 제작 지원(20개사)</td>
                        <td>
                          · 금속소재산업 시제품 제작지원 20개사 / 40명 고용 창출
                          <br />
                          (재료비, 외주용역비, 시험분석비, 금형비, PCB 등)
                        </td>
                      </tr>
                      <tr>
                        <td>ISO 인증 지원(20개사)</td>
                        <td>
                          · 저탄소 분야 ISO 인증지원 20개사 / 20명 고용 창출
                        </td>
                      </tr>
                      <tr>
                        <td>환경 개선 지원(6개사)</td>
                        <td>· 사업장 환경 개선 지원 6개사 / 6명 고용 창출</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChungnamInnovationProject;
